import React, { Fragment, useEffect } from "react";
import { dateFilterParams, dateValueGetter, formatOnlyDate } from "../utils";
import {
  fetchClearDetailPromotion,
  fetchDeletePromotion,
} from "../actions/promotion";

import AggridTable from "../components/Admin/Reusable/AggridTable";
import Breadcrumb from "../components/Admin/Reusable/Breadcrumb";
import ButtonColumn from "../components/Admin/Reusable/ButtonColumn";
import { fetchPromotionList } from "../actions/promotion";
import { statusRender } from "../utils/cellRenderTable";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

const PromotionList = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  //breadcrumb
  const translateModule = "promotions";
  const pageType = "List";
  const breadcrumbItems = [
    { label: t(`breadcrumb.${translateModule}`) },
    {
      label: t(`breadcrumb.${translateModule}${pageType}`),
      active: true,
    },
  ];

  const { promotionList } = useSelector((state) => state.promotionReducer);

  useEffect(() => {
    dispatch(fetchPromotionList());
    dispatch(fetchClearDetailPromotion());
  }, [dispatch]);

  const customCellRenderer = (params) => {
    if (!params.data || !params.data.id || !params.data.name) return null;
    return (
      <ButtonColumn
        editLink={`/promotion-edit/` + params.data.id}
        value={params}
        submitActionModal={handleSubmitModal}
      />
    );
  };

  const handleSubmitModal = (pageId) => {
    dispatch(fetchDeletePromotion(pageId));
  };

  const imageRenderer = (params) => {
    if (!params.data || !params.data.banner || !params.data.name) return null;
    return (
      <img
        src={params.data.banner}
        alt={params.data.name}
        className="image-aggrid-cell"
      />
    );
  };

  //settings za tabelu
  const columnDefs = [
    {
      headerName: t("promotionList.countryName"),
      field: "countryName",
      filter: "agSetColumnFilter",
      width: 150,
      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
    },
    {
      headerName: t("promotionList.banner"),
      field: "banner",
      width: 130,
      cellRenderer: imageRenderer,
      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
    },
    {
      headerName: t("promotionList.name"),
      field: "name",
      filter: "agTextColumnFilter",
      flex: 1,
      minWidth: 220,
      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
    },
    {
      headerName: t("promotionList.startDate"),
      field: "startDate",
      filter: "agDateColumnFilter",
      valueGetter: dateValueGetter,
      filterParams: dateFilterParams,
      valueFormatter: (params) => formatOnlyDate(params.value),
      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
    },
    {
      headerName: t("promotionList.endDate"),
      field: "endDate",
      filter: "agDateColumnFilter",
      valueGetter: dateValueGetter,
      filterParams: dateFilterParams,
      valueFormatter: (params) => formatOnlyDate(params.value),
      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
    },
    {
      headerName: t("promotionList.status"),
      field: "status",
      filter: "agSetColumnFilter",
      cellRenderer: statusRender,
      valueGetter: (params) => {
        if (!params.data || !params.data.status) return null;
        switch (params.data.status) {
          case "INACTIVE":
            return t("promotionList.statusInactive");
          case "ACTIVE":
            return t("promotionList.statusActive");
          default:
            return "";
        }
      },
      width: 150,
      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
    },
    {
      headerName: t("promotionList.createdAt"),
      field: "createdAt",
      filter: "agDateColumnFilter",
      valueGetter: dateValueGetter,
      filterParams: dateFilterParams,
      valueFormatter: (params) => formatOnlyDate(params.value),
      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
    },
    {
      headerName: t("promotionList.updatedAt"),
      field: "updatedAt",
      filter: "agDateColumnFilter",
      valueGetter: dateValueGetter,
      filterParams: dateFilterParams,
      valueFormatter: (params) => formatOnlyDate(params.value),
      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
    },
    {
      headerName: "",
      field: "custom",
      cellRenderer: customCellRenderer,
      pinned: "right",
      width: 60,
      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
    },
  ];

  return (
    <Fragment>
      <Breadcrumb
        type={translateModule}
        pageType={pageType}
        breadcrumbItems={breadcrumbItems}
      />
      <AggridTable
        rowData={promotionList}
        columnDefs={columnDefs}
        rowHeight={60}
        buttonLink={`/promotion-add`}
        buttonText={t(`breadcrumb.${translateModule}Add`)}
        gridStateKey={"promotion-list"}
      />
    </Fragment>
  );
};

export default PromotionList;
